import SecureBaseModel from './SecureBaseModel';

class TransitionModel extends SecureBaseModel {

    //These have to match with the routes in backend > APIController
    static TRANSITION_SUBSCRIBER_TYPE = 'transition-subscriber-type';
    static TRANSITION_SUBSCRIBE = 'transition-subscribe';

    static TRANSITION_TYPE_CCC = 'CCC';
    static TRANSITION_TYPE_RESUME = 'RESUME';
    static TRANSITION_TYPE_UPGRADE = 'UPGRADE';

    static OLD_SUBSCRIBER = "OS";
    static NEW_SUBSCRIBER = "NS";

    constructor() {
        super();
    }

    async subscriberType(params) {
        return await this.postData(TransitionModel.TRANSITION_SUBSCRIBER_TYPE, params);
    }

    // params { userId: value, sessionId: value, csMatNo: value, paymentMethodId: value, subscriber: { name: value }, transitionType: value }
    async subscribe(params) {
        return await this.postData(TransitionModel.TRANSITION_SUBSCRIBE, params);
    }
}

export default TransitionModel;
